export default __webpack_public_path__ + "static/media/profilePicture.d145a5ce.jpeg";